module.exports = __webpack_public_path__ + "static/media/wavm8s-013-arigto.5f72551.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-013-arigto.mp3
// module id = 8Arr
// module chunks = 0